module.exports = __webpack_public_path__ + "img/elixir.0c7ae7f2.svg";